<template>
  <v-card
    :id="`servo-${servo.s}-${sIdx}`"
    variant="outlined"
    class="mb-3"
  >
    <div class="pl-4 pr-4 d-flex align-center">
      <span class="text-subtitle-1 text-high-emphasis font-weight-light">
        {{ servo.name }} <span style="font-size:14px;color:#1976d2;font-weight:bold;">[ID: {{ servo.s }}]</span> <span style="font-size:14px;color:#888;">(运动范围：{{
          servo.range ? servo.range[0] : 0
        }} 到 {{ servo.range ? servo.range[1] : 0 }})</span>
        <span style="font-size:14px;color:#888;margin-left:8px;"> 运行总时长：{{
            getServoTotalTime(servo)
          }} ms</span>

      </span>
      <v-spacer></v-spacer>
      <v-col cols="2" style="max-width:120px;">
        <v-text-field v-model.number="servo.l" label="循环次数" type="number" min="1" density="compact"
                      variant="outlined" hide-details/>
      </v-col>
      <div v-show="sevroDebug">
        <!-- https://vuetifyjs.com/en/styles/colors/#material-colors -->

        <v-btn class="text-none" variant="text" border
               @click="handleAngleChange(servo, 'Origin', servo.angleDebug)">
          保存Origin
        </v-btn>
        <v-btn class="text-none" variant="text" border
               @click="handleAngleChange(servo, 'Min', servo.angleDebug)">
          保存Min
        </v-btn>
        <v-btn class="text-none" variant="text" border
               @click="handleAngleChange(servo, 'Max', servo.angleDebug)">
          保存Max
        </v-btn>
        <v-btn class="text-none" variant="text" border
               @click="handleAngleChange(servo, 'Def', servo.angleDebug)">
          保存Def
        </v-btn>
      </div>
      <v-btn prepend-icon="mdi-delete" class="ml-3 me-2 text-none" color="red-lighten-2"
             variant="outlined"
             @click="removeServo(sIdx)">删除
      </v-btn>
    </div>
    <v-divider></v-divider>
    <v-card-text>
      <v-row dense align="center">
        <v-col cols="4">
          <v-text-field
              v-show="sevroDebug"
              v-model.number="servo.angleDebug" label="调试绝对角度" type="number"
              :min="servo.range?servo.range[0]:-200"
              :max="servo.range?servo.range[1]:200"
              style="width:180px;" density="compact" variant="outlined" class="mx-1"
              @update:modelValue="handleAngleChange(servo, 'Debug', servo.angleDebug)"
          /></v-col>
        <v-col cols="4">
          <v-text-field
              v-show="sevroDebug"
              hideInput
              v-model.number="servo.angleDebug2" label="调试相对角度" type="number"
              :min="-200"
              :max="200"
              @update:modelValue="handleAngleChange(servo, 'DebugRelative', servo.angleDebug2)"
              style="width:180px;" density="compact" variant="outlined" class="mx-1"/>
        </v-col>

        <v-col cols="12">
          <div style="font-weight:500;" class="pb-3">操作片段：</div>
          <template v-for="(motion, mIdx) in servo.m" :key="mIdx">
            <div v-if="motion && motion.steps !== undefined" class="d-flex align-center">
              <v-text-field v-model.number="motion.steps" label="步(20ms/步)" type="number"
                            :min="servo.range?servo.range[0]:-200"
                            :max="servo.range?servo.range[1]:200"
                            style="width:120px;" density="compact" variant="outlined"/>
              <span class="mx-2">参数：</span>
              <v-text-field v-model.number="motion.param[0]" label="开始角度" type="number"
                            :min="servo.range?servo.range[0]:-200"
                            :max="servo.range?servo.range[1]:200"
                            style="width:90px;" density="compact" variant="outlined" class="mx-1"/>
              <v-text-field v-model.number="motion.param[2]" label="1/3点y坐标" type="number"
                            :min="servo.range?servo.range[0]:-200"
                            :max="servo.range?servo.range[1]:200"
                            style="width:110px;" density="compact" variant="outlined" class="mx-1"/>
              <v-text-field v-model.number="motion.param[3]" label="2/3点y坐标" type="number"
                            :min="servo.range?servo.range[0]:-200"
                            :max="servo.range?servo.range[1]:200"
                            style="width:110px;" density="compact" variant="outlined" class="mx-1"/>
              <v-text-field :model-value="motion.param[1]" label="结束角度" type="text"
                            @update:model-value="(val) => { motion.param[1] = val === '' || /^-?\d*\.?\d*$/.test(val) ? val : motion.param[1]; }"
                            style="width:90px;" density="compact" variant="outlined" class="mx-1"/>
              <v-btn
                v-if="isDualServo(sIdx)"
                size="small"
                color="primary"
                variant="outlined"
                class="mx-1"
                @click="setCurrentAngleForDualServo(sIdx, mIdx)"
              >
                设置当前角度
              </v-btn>
              <v-btn size="small" color="primary" variant="outlined" class="mx-1"
                     @click="addMotion(sIdx, mIdx)">
                添加片段
              </v-btn>
              <v-btn prepend-icon="mdi-delete" color="red" variant="text"
                     @click="removeMotion(sIdx, mIdx)"/>
            </div>
          </template>
          <v-btn size="small" color="primary" variant="outlined" @click="addMotion(sIdx)">添加片段</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { inject } from 'vue'

defineProps({
  servo: { type: Object, required: true },
  sIdx: { type: Number, required: true }
})

// 由 App.vue provide 的舵机管理器（含双舵机设置当前角度）
const {
  sevroDebug,
  getServoTotalTime,
  handleAngleChange,
  removeServo,
  addMotion,
  removeMotion,
  isDualServo,
  setCurrentAngleForDualServo
} = inject('servoManager')
</script>
